import { Form, Input, Segmented } from 'antd';
import { ChatIcon, PhoneFilledIcon } from 'assets';
import OmniChannelSourceSelect from 'components/omni-channel-chat-histories/OmniChannelSourceSelect';
import { useAIAgentCenterContext } from 'contexts/ai-agent-center';
import { aiAgentCenterMessages, messages } from 'messages';
import React, { memo } from 'react';
import CallChannelSourceSelect from './CallChannelSourceSelect';
import { DateRangePicker, InputSearch } from 'components/common';
type Props = {
  onSearchCall: () => void;
  onSearchChat: () => void;
};
const AIAgentCenterSessionsFilter: React.FC<Props> = ({ onSearchCall, onSearchChat }) => {
  const { type, setType, form } = useAIAgentCenterContext();

  const handleSearchCall = (value: string) => {
    if (form.getFieldValue('keywordCall') === value) {
      setTimeout(() => {
        onSearchCall();
      }, 200);
    }
    form.setFieldValue('keywordCall', value);
  };

  const handleSearchChat = (value: string) => {
    if (form.getFieldValue('keywordChat') === value) {
      setTimeout(() => {
        onSearchChat();
      }, 200);
    }
    form.setFieldValue('keywordChat', value);
  };

  return (
    <div className='flex flex-col gap-3 px-5 pb-2 pt-3'>
      <Segmented
        prefixCls='main-segmented'
        className='w-full'
        options={[
          {
            value: 'phone',
            label: aiAgentCenterMessages.calls
          },
          {
            value: 'chat',
            label: aiAgentCenterMessages.chat
          }
        ]}
        value={type}
        onChange={(value) => setType(value as 'phone' | 'chat')}
      />
      {type === 'chat' ? (
        <div className='flex flex-col gap-2'>
          <div className='flex w-full items-center gap-2'>
            <div className='w-[158px]'>
              <Form.Item name={'chatSource'} noStyle>
                <OmniChannelSourceSelect
                  prefix={<ChatIcon height={14} width={14} />}
                  className='w-full'
                  isAll
                  placeholder={aiAgentCenterMessages.channelChat}
                />
              </Form.Item>
            </div>
            <div className='flex-1'>
              <Form.Item name={'dateRange'} noStyle>
                <DateRangePicker
                  format={'DD/MM/YYYY'}
                  className='w-full'
                  placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                />
              </Form.Item>
            </div>
          </div>
          <div>
            <Form.Item name={'keywordChat'} noStyle>
              <InputSearch
                debounceTime={2000}
                placeholder={aiAgentCenterMessages.keywordChat}
                onPressEnter={(e) => {
                  handleSearchChat(e.currentTarget.value);
                }}
                onBlur={(e) => {
                  form.setFieldValue('keywordChat', e.currentTarget.value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      ) : (
        <div className='flex flex-col gap-2'>
          <div className='flex w-full items-center gap-2'>
            <div className='w-[158px]'>
              <Form.Item name={'callSource'} noStyle>
                <CallChannelSourceSelect
                  prefix={<PhoneFilledIcon height={14} width={14} />}
                  isAll
                  placeholder={aiAgentCenterMessages.callChanel}
                  allItemLabel={messages.all}
                />
              </Form.Item>
            </div>
            <div className='flex-1'>
              <Form.Item name={'callDateRange'} noStyle>
                <DateRangePicker
                  format={'DD/MM/YYYY'}
                  className='w-full'
                  placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                />
              </Form.Item>
            </div>
          </div>
          <div>
            <Form.Item name={'keywordCall'} noStyle>
              <InputSearch
                debounceTime={1000}
                placeholder={aiAgentCenterMessages.keywordCall}
                onPressEnter={(e) => {
                  handleSearchCall(e.currentTarget.value);
                }}
                onBlur={(e) => {
                  form.setFieldValue('keywordCall', e.currentTarget.value);
                }}
              />
            </Form.Item>
          </div>
        </div>
      )}
    </div>
  );
};
export default memo(AIAgentCenterSessionsFilter);
